import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import DataGrid, { Column, Scrolling } from "devextreme-react/data-grid";
import { BuyBackReturnToFranchise, GetCustomerBankDetailByCustomerIdId, InsertCustomerBankDetails } from "../services/CustomerToFranchaiase.service";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";
import { formatValue } from "../services/amountFormater";
import Loader from "Common/Loader";
import BankFormModal from "./BankForm";

const ReturnBuyBackDetails: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [returnDataState, setReturnDataState] = useState<any | null>(null);
    const [bankId, setBankId] = useState<number | null>(null);

    const [loading, setLoading] = useState(false);
    const [customerBankDetails, setCustomerBankDetails] = useState<any>(null);
    const [selectedBankDetails, setSelectedBankDetails] = useState<any | null>(null);
    const [openBankForm, setOpenBankForm] = useState(false);

    const items = returnDataState?.returnSalesOrderItems ?? [];

    useEffect(() => {
        if (location.state?.returnData) {
            setReturnDataState(location.state.returnData);

            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const transformedData = {
        returnSalesOrderModel: {
            salesOrderId: returnDataState?.returnSalesOrderModel?.salesOrderId ?? 0,
            totalReturnSaleOrderAmount: items[0]?.returnSaleOrderAmount ?? 0,
            totalQuantity: 1,
            returnSaleType: "BuyBack",
            customerId: items[0]?.customerId ?? 0,
            customerBankId: bankId,
            storeId: returnDataState?.returnSalesOrderModel?.storeId,
            salesPersonId: returnDataState?.returnSalesOrderModel?.salesPersonId,
            paymentType: '',
            paymentReferenceNumber: '',
            description: ''
        },
        returnSalesOrderItems: items.map((item: any) => ({
            styleNo: item?.styleNo ?? 0,
            categoryName: item?.categoryName ?? '',
            diamondWeight: item?.diamondWeight ?? 0,
            netWeight: item?.netWeight ?? 0,
            actualNetWeight: 0,
            grossWeight: 0,
            metalPrice: 0,
            laborPrice: item?.laborPrice ?? 0,
            diamondQuantity: item?.diamondQuantity ?? 0,
            quantity: 1,
            saleOrderAmount: item?.saleOrderAmount ?? 0,
            returnSaleOrderAmount: 0,
            materialTypeId: item?.materialTypeId ?? 0,
            materialTypeName: item?.materialTypeName ?? '',
            productHeaderId: item?.productHeaderId ?? 0,
            customerId: item?.customerId ?? 0,
            salesOrderItemId: items[0]?.id,
            refundRewardPoints: item?.refundRewardPoints ?? 0,
            rewardExpiryDays: item?.rewardExpiryDays ?? 0
        }))
    };

    const [isSubmitting, setSubmitting] = useState(false);
    const bankDetails = async (data: any) => {
        const payload = {
            bankName: data.bankName,
            accountHolderName: data.accountHolderName,
            accountNo: data.accountNo,
            ifsc: data.ifsc,
            url: data.url,
            customerId: items[0]?.customerId ?? 0,
        }

        try {
            setSubmitting(true);
            const response = await InsertCustomerBankDetails(payload);

            if (response.status === HttpStatus.Success) {
                const newBankId = response.data;

                setBankId(newBankId);

                await getBankDetails();

                return newBankId;
            }
        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    const handleReturn = async () => {
        if (!bankId) {
            notistack.warning("Please add bank details before confirming the buy back.");
            return;
        }
        setLoading(true);
        try {
            const response = await BuyBackReturnToFranchise(transformedData);
            if (response.status === HttpStatus.Success) {
                notistack.notifyFromApi(response);
                navigate(-1);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const handleAddBankDetails = () => {
        setOpenBankForm(true);
    };

    const getBankDetails = async () => {
        try {
            const response = await GetCustomerBankDetailByCustomerIdId(items[0]?.customerId ?? 0);
            if (response.status === HttpStatus.Success) {
                setCustomerBankDetails(response.data);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.error(error);
        }
    }

    useEffect(() => {
        if (items[0]?.customerId) {
            getBankDetails();
        }
    }, [items[0]?.customerId]);

    if (!returnDataState) {
        return (
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Body className="text-center">
                            <h5>No Buy Back data available</h5>
                            <button className="btn submit-btn mt-3" onClick={() => navigate(-1)}>
                                Go Back
                            </button>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    return (
        <>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid" style={{ overflow: "auto" }}>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className='m-0'>Buy Back Details</h5>
                            <div className="d-flex align-content-center justify-content-end gap-2">
                                <button className="btn submit-btn" onClick={handleAddBankDetails}>
                                    Add Bank Details
                                </button>
                            </div>
                        </Card.Header>

                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-start mb-2">

                                <div className="row py-3" style={{ width: "60%" }}>
                                    <div className="col-md-12">
                                        <h6 className="fw-bold">Price</h6>

                                        <div className="row">
                                            <div className="col-sm-6 mb-2">
                                                <label className="form-label small">IGI NO </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={items[0]?.igiNo ?? ''}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col-sm-6 mb-2">
                                                <label className="form-label small">Buy Back Price </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={
                                                        returnDataState?.returnSalesOrderModel?.totalReturnSaleOrderAmount != null
                                                            ? returnDataState.returnSalesOrderModel.totalReturnSaleOrderAmount.toFixed(2)
                                                            : ""
                                                    }
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <p className="fw-bold text-info">
                                            The deduction is just for calculation, not the final amount.
                                        </p>
                                    </div>
                                </div>

                                <div className="row" style={{ width: "50%" }}>
                                    <div className="overflow-auto" style={{ height: '300px' }}>
                                        <h6 className="fw-bold text-center mb-0">Deduction Summary</h6>

                                        {items?.map((item: any, index: number) => (
                                            <div key={item?.id || index} className="card p-0 mb-0 shadow-sm border-0 rounded-3">
                                                <div className="card-body mb-0 p-2 border-bottom">
                                                    <h6 className="fw-semibold">
                                                        {item?.categoryName} (Style No: {item?.styleNo})
                                                    </h6>

                                                    <table className="table table-sm table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Header</th>
                                                                <th>Original Amt</th>
                                                                <th>Buy Back Amt</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {Object.entries(item?.deductionSummarys || {}).map(([key, value]: any) => (
                                                                <tr key={key}>
                                                                    <td><strong>{key}</strong></td>
                                                                    <td>{formatValue(value?.orignalAmount)}</td>
                                                                    <td>{formatValue(value?.returnAmount)}</td>
                                                                </tr>
                                                            ))}

                                                            {/* <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "red" }}>
                                                                <td>Total</td>
                                                                <td>
                                                                    {formatValue(
                                                                        Object.values(item?.deductionSummarys || {}).reduce(
                                                                            (sum: number, v: any) => sum + (v?.orignalAmount || 0),
                                                                            0
                                                                        )
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {formatValue(
                                                                        Object.values(item?.deductionSummarys || {}).reduce(
                                                                            (sum: number, v: any) => sum + (v?.returnAmount || 0),
                                                                            0
                                                                        )
                                                                    )}
                                                                </td>
                                                            </tr> */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <DataGrid
                                dataSource={items}
                                keyExpr="id"
                                showBorders
                                showRowLines
                                columnAutoWidth
                            >
                                <Scrolling
                                    mode="standard"
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Column dataField="styleNo" caption="Style No" width={120} />
                                <Column dataField="categoryName" caption="Category" width={150} />
                                <Column dataField="diamondWeight" caption="Dia.Wt" dataType="number" width={100} format="#,##0.000" />
                                <Column dataField="diamondQuantity" caption="Dia.Qty" dataType="number" width={100} />
                                <Column dataField="netWeight" caption="Net Wt" dataType="number" width={100} format="#,##0.000" />
                                <Column dataField="grossWeight" caption="Gross Wt" dataType="number" width={100} format="#,##0.000" />
                                <Column dataField="metalPrice" caption="Metal Price" dataType="number" width={120} format="#,##0.00" />
                                <Column dataField="laborPrice" caption="Lab Price" dataType="number" width={100} format="#,##0.00" />
                                <Column dataField="diamonMrp" caption="Dia Price" dataType="number" width={100} format="#,##0.00" />
                                <Column dataField="colorStonePrice" caption="Stone Price" dataType="number" width={100} format="#,##0.00" />
                                <Column dataField="igiNo" caption="IGI NO" width={100} />
                                <Column dataField="saleOrderAmount" caption="Selling Price" dataType="number" width={100} format="#,##0.00" />
                                <Column dataField="returnSaleOrderAmount" caption="Buy Back Price" dataType="number" width={100} format="#,##0.00" />
                            </DataGrid>

                            <div className="d-flex justify-content-end gap-3 p-4">
                                Total Price :
                                {returnDataState?.returnSalesOrderModel?.totalReturnSaleOrderAmount?.toFixed(2)}

                                <button className="btn add-btn" onClick={handleCancel}>
                                    Cancel
                                </button>

                                <button className="submit-btn btn" onClick={handleReturn}>
                                    Confirm
                                </button>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <BankFormModal
                isOpen={openBankForm}
                onclose={() => setOpenBankForm(false)}
                bankDetails={bankDetails}
                customerBankDetails={customerBankDetails}
                selectedBankDetails={selectedBankDetails}
                setSelectedBankDetails={setSelectedBankDetails}
                setBankId={setBankId}
                isSubmitting={isSubmitting}
                getBankDetails={getBankDetails}
            />
        </>
    );
};

export default ReturnBuyBackDetails;